import { render, staticRenderFns } from "./order-distribute-no-manage.vue?vue&type=template&id=d67445ca&scoped=true&"
import script from "./order-distribute-no-manage.vue?vue&type=script&lang=js&"
export * from "./order-distribute-no-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67445ca",
  null
  
)

export default component.exports